import { API_BASE_URL } from '../client';

export const OPPORTUNITY_ENDPOINTS = {
  OPPORTUNITY: {
    LIST: `${API_BASE_URL}/Opportunity`,
    EXPORT: `${API_BASE_URL}/Opportunity/export`,
    EXPORT_DETAIL: (id: number) => `${API_BASE_URL}/Opportunity/${id}/export`,
    DETAIL: (id: number) => `${API_BASE_URL}/Opportunity/${id}`,
    CREATE: `${API_BASE_URL}/Opportunity`,
    UPDATE: `${API_BASE_URL}/Opportunity`,
    DELETE: (id: number) => `${API_BASE_URL}/Opportunity/${id}`,
    SYNC_MATCH: `${API_BASE_URL}/Opportunity/sync-match`,
  },
  BRIEF_CYCLE: {
    GET: `${API_BASE_URL}/BriefCycleConfig`,
    SAVE: `${API_BASE_URL}/BriefCycleConfig`,
    TRIAL: `${API_BASE_URL}/BriefCycleConfig/trial`,
  },
  PLAN_VERSION: {
    LIST: `${API_BASE_URL}/PlanVersion`,
    DETAIL: (id: number) => `${API_BASE_URL}/PlanVersion/${id}`,
    BOARD: (id: number) => `${API_BASE_URL}/PlanVersion/${id}/board`,
    EXPORT: (id: number) => `${API_BASE_URL}/PlanVersion/${id}/export`,
    CREATE: `${API_BASE_URL}/PlanVersion`,
    UPDATE: `${API_BASE_URL}/PlanVersion`,
    PUBLISH: (id: number) => `${API_BASE_URL}/PlanVersion/${id}/publish`,
    BRING: `${API_BASE_URL}/PlanVersion/bring`,
  },
};
